import { render, staticRenderFns } from "./CalculoCosto.vue?vue&type=template&id=04310cfe&scoped=true&"
import script from "./CalculoCosto.vue?vue&type=script&lang=js&"
export * from "./CalculoCosto.vue?vue&type=script&lang=js&"
import style0 from "./CalculoCosto.vue?vue&type=style&index=0&id=04310cfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04310cfe",
  null
  
)

export default component.exports